import { FormatMessageFunction } from '@common/types/Translation';
import { PASSWORD_REQUIREMENTS_REGEX } from '@constants/user';
import * as Yup from 'yup';

export const createSetNewPasswordValidationSchema = (formatMessage: FormatMessageFunction) =>
    Yup.object({
        new_password: Yup.string()
            .required(
                formatMessage(
                    {
                        id: 'schema.errors.required',
                        defaultMessage: '{field} is required',
                        description: 'Error message displayed when user leaves a mandatory field empty. Used in forms',
                    },
                    { field: formatMessage({ id: 'auth.fields.password.new', defaultMessage: 'New password' }) }
                )
            )
            .matches(
                PASSWORD_REQUIREMENTS_REGEX,
                formatMessage({
                    id: 'schema.errors.password.requirements',
                    defaultMessage:
                        'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character',
                    description:
                        'Error message displayed when user enters a value that does not match the required format. Used in forms',
                })
            )
            .min(10, ({ min }) =>
                formatMessage(
                    {
                        id: 'schema.errors.min',
                        defaultMessage: '{field} must be at least {min} characters long',
                        description:
                            'Error message displayed when user enters a value that is shorter than the required minimum length. Used in forms',
                    },
                    { field: formatMessage({ id: 'auth.fields.password.new', defaultMessage: 'New password' }), min }
                )
            ),

        confirm_new_password: Yup.string()
            .required(
                formatMessage(
                    {
                        id: 'schema.errors.required',
                        defaultMessage: '{field} is required',
                        description: 'Error message displayed when user leaves a mandatory field empty. Used in forms',
                    },
                    { field: formatMessage({ id: 'auth.fields.newPassword.confirm', defaultMessage: 'Confirm new password' }) }
                )
            )
            .oneOf(
                [Yup.ref('new_password')],
                formatMessage(
                    {
                        id: 'schema.errors.mismatch',
                        defaultMessage: '{field} do not match',
                        description:
                            'Error message displayed when two fields that should match do not have the same value. Used in forms',
                    },
                    { field: formatMessage({ id: 'auth.fields.newPassword.confirm', defaultMessage: 'Passwords' }) }
                )
            ),
    });
